import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getData } from "../newApis/apiMethods";

const getDateSearchMode = async () => {
  const data = await getData(ajaxEndpoints.GET_INVESTMENT_DATE_SEARCH_MODE);
  return data;
};

export default function useGetDateSearchMode() {
  return useQuery(["getDateSearchMode"], getDateSearchMode);
}
